// Datos generales de la tienda Agora. Centralizados para facilitar el
// mantenimiento: cambiar un dato aqui lo actualiza en toda la web.

export const TIENDA = {
  nombre: "Agora",
  producto: "Mantequilla de Maní Natural",
  precio: 9000,
  precioFormateado: "$9.000 CLP",
  peso: "1 Kg",
  whatsapp: "+56 9 7743 4200",
  whatsappNumero: "56977434200",
  instagram: "agoramani.cl",
  instagramUrl: "https://www.instagram.com/agoramani.cl",
  ciudad: "Viña del Mar",
  horario: "Todos los días de 8:00 AM a 19:00 PM",
};

// Mensaje estandar para los botones de compra.
export const MENSAJE_COMPRA =
  "Hola, buenas tardes, estoy interesado en comprar la mantequilla de maní natural de Agora (frasco de 1 Kg a $9.000 CLP). ¿Cómo puedo realizar mi pedido?";
